export default __webpack_public_path__ + "static/media/image 2.8697273c.png";